/**
 * Sentry initialization for quantix-web.
 * Uses the same project/DSN as quantix-api (set VITE_SENTRY_DSN to the same value as SENTRY_LARAVEL_DSN).
 */
import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN;
const enabled = import.meta.env.VITE_SENTRY_ENABLED !== 'false';

if (dsn && enabled) {
    Sentry.init({
        dsn,
        environment: import.meta.env.MODE,
        tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? '0.5'),
        // Session Replay: don't record normal sessions, only capture the replay
        // buffer when an error actually occurs.
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0,
        integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
        // Expected auth/network conditions (unauthenticated page loads, requests
        // aborted by a login redirect) are not actionable bugs — don't report them.
        ignoreErrors: [
            'No response received from server',
            'Request failed with status code 401',
            'Non-Error promise rejection captured',
        ],
        beforeSend(event, hint) {
            const exception = hint?.originalException as { message?: string } | string | undefined;
            const message = typeof exception === 'string' ? exception : (exception?.message ?? '');
            if (/No response received from server|status code 401/i.test(message)) {
                return null;
            }
            return event;
        },
    });
}

export { Sentry };
